import { Dropdown, PhoneNumberInput, TextField } from "components";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import countryList from "react-select-country-list";
import { usaStates } from "typed-usa-states";
export enum ContactDetailsFormEnum {
  Phone = "phone",
  Country = "country",
  State = "state",
  City = "city",
}
const ContactDetailsStep = () => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();
  const [countrySelectValue, stateSelectValue, phoneValue] = watch([
    ContactDetailsFormEnum.Country,
    ContactDetailsFormEnum.State,
    ContactDetailsFormEnum.Phone,
  ]);
  const countryOptions = useMemo(() => countryList().getData(), []);
  const statesOptions = useMemo(
    () =>
      usaStates.map(({ name }) => ({
        value: name,
        label: name,
      })),
    []
  );
  return (
    <div className="space-y-4">
      <PhoneNumberInput
        errors={errors}
        isRequired
        label="Phone number"
        {...register(ContactDetailsFormEnum.Phone)}
        defaultPrefix="46"
        initialValue={phoneValue}
        onChange={(phoneNumber) =>
          setValue(ContactDetailsFormEnum.Phone, phoneNumber, {
            shouldValidate: true,
          })
        }
        placeholder="Phone number"
      />
      <Dropdown
        {...register(ContactDetailsFormEnum.Country)}
        errors={errors}
        isRequired
        label="Country or Region"
        onChange={({ label }) =>
          setValue(ContactDetailsFormEnum.Country, label)
        }
        options={countryOptions}
        placeholder="Country"
        value={
          countrySelectValue
            ? countryOptions.find((opt) => opt.label === countrySelectValue)
            : undefined
        }
      />
      {countrySelectValue === "United States" && (
        <Dropdown
          {...register(ContactDetailsFormEnum.State)}
          errors={errors}
          isRequired
          label="State"
          onChange={({ value }) =>
            setValue(ContactDetailsFormEnum.State, value)
          }
          options={statesOptions}
          placeholder="State"
          value={
            stateSelectValue
              ? statesOptions.find((opt) => opt.label === stateSelectValue)
              : undefined
          }
        />
      )}
      <TextField
        autoComplete="city"
        errors={errors}
        label="City"
        placeholder="City"
        {...register(ContactDetailsFormEnum.City)}
      />
    </div>
  );
};
export default ContactDetailsStep;
